var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sz-table',{ref:"table",attrs:{"columns":_vm.columns,"table-data":_vm.tableData}})
}
var staticRenderFns = []

export { render, staticRenderFns }